import { SvgIconProps } from "@material-ui/core";
import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

const CheckboxHover = createSvgIcon(
  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3_15571)">
      <rect x="3" y="3" width="16" height="16" rx="4" fill="white" />
      <rect x="3.5" y="3.5" width="15" height="15" rx="3.5" stroke="#009FB8" />
    </g>
    <defs>
      <filter
        id="filter0_d_3_15571"
        x="0"
        y="0"
        width="22"
        height="22"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_3_15571"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.698039 0 0 0 0 0.929412 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3_15571"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3_15571"
          result="shape"
        />
      </filter>
    </defs>
  </svg>,
  "CheckboxHover"
);

export default (props: SvgIconProps) => (
  <CheckboxHover {...props} viewBox="0 0 22 22" transform="scale(1.357)" />
);
